if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
      });
      if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      if (event.detail.currentElement == undefined) return;

      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

/* =========================================================
   4PIXELS — MOBILE PRODUCT GALLERY VERTICAL SCROLL GUARD
   Vertical finger movement scrolls the page normally.
   A clearly horizontal gesture is still passed to the custom image swipe.
   ========================================================= */
(function () {
  function initVerticalScrollGuard(scope) {
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;

    var base = scope && scope.querySelectorAll ? scope : document;
    var galleries = [];

    if (base.matches && base.matches('media-gallery')) galleries.push(base);
    if (base.querySelectorAll) {
      base.querySelectorAll('media-gallery').forEach(function (gallery) {
        galleries.push(gallery);
      });
    }

    galleries.forEach(function (gallery) {
      if (!gallery || gallery.dataset.fpVerticalScrollGuard === 'true') return;
      gallery.dataset.fpVerticalScrollGuard = 'true';

      var touchTargets = gallery.querySelectorAll(
        '[id^="GalleryViewer"], [id^="Slider-Gallery"], product-gallery, use-animate, .product__media-item, .product__modal-opener, .product__media-toggle, .product__media, .media-wrapper, lazy-image, img, video, model-viewer'
      );

      gallery.style.touchAction = 'pan-y pinch-zoom';
      touchTargets.forEach(function (element) {
        element.style.touchAction = 'pan-y pinch-zoom';
      });

      var startX = 0;
      var startY = 0;
      var direction = '';

      gallery.addEventListener('touchstart', function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        direction = '';
      }, { capture: true, passive: true });

      gallery.addEventListener('touchmove', function (event) {
        if (!event.touches || event.touches.length !== 1) return;

        var dx = event.touches[0].clientX - startX;
        var dy = event.touches[0].clientY - startY;
        var absX = Math.abs(dx);
        var absY = Math.abs(dy);

        if (!direction && Math.max(absX, absY) >= 7) {
          direction = absX > absY * 1.35 ? 'horizontal' : 'vertical';
        }

        if (direction === 'vertical') {
          event.stopPropagation();
        }
      }, { capture: true, passive: true });

      function resetDirection() {
        direction = '';
      }

      gallery.addEventListener('touchend', resetDirection, { capture: true, passive: true });
      gallery.addEventListener('touchcancel', resetDirection, { capture: true, passive: true });
    });
  }

  function ready() {
    initVerticalScrollGuard(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initVerticalScrollGuard(event.target);
  });
})();

/* =========================================================
   4PIXELS PDP RATING ORDER FINAL 2026-08-19
   Title first. Rating on its own right-aligned row. Price + heart after it.
   ========================================================= */
(function () {
  var STYLE_ID = 'fp-pdp-rating-order-final';

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
body.template-product #MainContent [id^="ProductInfo-"] .product__title {
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
}

body.template-product #MainContent [id^="ProductInfo-"] .tetiano-title-review-row {
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  direction: inherit !important;
}

body.template-product #MainContent [id^="ProductInfo-"] .tetiano-title-review-row h1,
body.template-product #MainContent [id^="ProductInfo-"] .product__title h1 {
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  flex: none !important;
  margin: 0 !important;
  padding: 0 !important;
  white-space: normal !important;
  overflow-wrap: anywhere !important;
  word-break: normal !important;
}

body.template-product #MainContent [id^="ProductInfo-"] .tetiano-rating-after-title {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  width: 100% !important;
  min-height: 15px !important;
  margin: 3px 0 8px !important;
  padding: 0 !important;
  direction: ltr !important;
}

body.template-product #MainContent [id^="ProductInfo-"] .tetiano-rating-after-title .tetiano-title-rating {
  display: inline-flex !important;
  position: static !important;
  inset: auto !important;
  align-items: center !important;
  justify-content: flex-end !important;
  align-self: auto !important;
  flex: none !important;
  width: auto !important;
  max-width: none !important;
  min-width: 0 !important;
  gap: 3px !important;
  margin: 0 !important;
  padding: 0 !important;
  transform: none !important;
  white-space: nowrap !important;
  line-height: 1 !important;
  direction: ltr !important;
}

body.template-product #MainContent [id^="ProductInfo-"] .tetiano-rating-after-title .tetiano-title-stars {
  display: inline-flex !important;
  gap: 0 !important;
  font-size: 13px !important;
  letter-spacing: .6px !important;
  line-height: 1 !important;
  color: #F5B301 !important;
  -webkit-text-fill-color: #F5B301 !important;
}

body.template-product #MainContent [id^="ProductInfo-"] .tetiano-rating-after-title .tetiano-title-rating-count {
  font-size: 10px !important;
  line-height: 1 !important;
  margin: 0 !important;
  padding: 0 !important;
  color: #111111 !important;
  -webkit-text-fill-color: #111111 !important;
}

body.template-product #MainContent [id^="ProductInfo-"] .aligan-price-actions {
  margin-top: 0 !important;
}

@media screen and (max-width: 749px) {
  body.template-product #MainContent [id^="ProductInfo-"] .tetiano-title-review-row h1,
  body.template-product #MainContent [id^="ProductInfo-"] .product__title h1 {
    font-size: 19px !important;
    line-height: 1.26 !important;
    font-weight: 600 !important;
    letter-spacing: 0 !important;
  }

  body.template-product #MainContent [id^="ProductInfo-"] .tetiano-rating-after-title {
    margin: 3px 0 8px !important;
  }
}
`;
    document.head.appendChild(style);
  }

  function placeRating(scope) {
    ensureStyles();

    var base = scope && scope.querySelectorAll ? scope : document;
    var infos = [];

    if (base.matches && base.matches('[id^="ProductInfo-"]')) infos.push(base);
    if (base.querySelectorAll) {
      base.querySelectorAll('[id^="ProductInfo-"]').forEach(function (info) {
        infos.push(info);
      });
    }

    infos.forEach(function (info) {
      var row = info.querySelector('.tetiano-title-review-row');
      var rating = info.querySelector('.tetiano-title-rating');
      if (!row || !rating) return;

      var holder = info.querySelector('.tetiano-rating-after-title');
      if (!holder) {
        holder = document.createElement('div');
        holder.className = 'tetiano-rating-after-title';
      }

      if (holder.previousElementSibling !== row) {
        row.insertAdjacentElement('afterend', holder);
      }

      if (rating.parentElement !== holder) {
        holder.appendChild(rating);
      }
    });
  }

  function init(scope) {
    placeRating(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

/* =========================================================
   4PIXELS — PDP COMPACT GALLERY + MOUSE DRAG FINAL 2026-08-19
   - Active image decides the mobile gallery height.
   - Mouse/pen can drag left/right just like touch swipe.
   - Vertical page scrolling stays normal.
   ========================================================= */
(function () {
  var MQ = '(max-width: 749px)';
  var STYLE_ID = 'fp-pdp-compact-gallery-mouse-drag';

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
@media screen and (max-width: 749px) {
  html body.template-product #MainContent#MainContent media-gallery {
    --fp-gallery-height: 280px;
  }

  html body.template-product #MainContent#MainContent media-gallery use-animate,
  html body.template-product #MainContent#MainContent media-gallery product-gallery,
  html body.template-product #MainContent#MainContent media-gallery [id^="GalleryViewer-"],
  html body.template-product #MainContent#MainContent media-gallery [id^="Slider-Gallery-"] {
    height: var(--fp-gallery-height) !important;
    min-height: var(--fp-gallery-height) !important;
    max-height: var(--fp-gallery-height) !important;
  }

  html body.template-product #MainContent#MainContent media-gallery [id^="Slider-Gallery-"] {
    cursor: grab !important;
    user-select: none !important;
    -webkit-user-select: none !important;
    touch-action: pan-y pinch-zoom !important;
  }

  html body.template-product #MainContent#MainContent media-gallery [id^="Slider-Gallery-"].fp-mouse-dragging {
    cursor: grabbing !important;
  }

  html body.template-product #MainContent#MainContent media-gallery [id^="Slider-Gallery-"].fp-mouse-dragging > .product__media-item {
    transition: none !important;
  }

  html body.template-product #MainContent#MainContent media-gallery [id^="Slider-Gallery-"] > .product__media-item.fp-drag-prev {
    inset-inline-start: calc(-80% - 7px) !important;
    opacity: 1 !important;
    visibility: visible !important;
    pointer-events: none !important;
    z-index: 1 !important;
  }

  html body.template-product #MainContent#MainContent media-gallery [id^="Slider-Gallery-"] > .product__media-item.fp-drag-next {
    inset-inline-start: calc(80% + 7px) !important;
    opacity: 1 !important;
    visibility: visible !important;
    pointer-events: none !important;
    z-index: 1 !important;
  }
}
`;
    document.head.appendChild(style);
  }

  function getSlides(slider) {
    return Array.prototype.slice.call(slider.querySelectorAll(':scope > .product__media-item'));
  }

  function getCurrentIndex(slider, list) {
    var active = slider.querySelector(':scope > .product__media-item.is-active');
    var index = list.indexOf(active);
    return index < 0 ? 0 : index;
  }

  function readRatio(img) {
    if (!img) return null;
    var width = img.naturalWidth || parseFloat(img.getAttribute('width')) || 0;
    var height = img.naturalHeight || parseFloat(img.getAttribute('height')) || 0;
    if (!(width > 0 && height > 0)) return null;
    return { width: width, height: height };
  }

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.fpCompactDragReady === 'true') return;

    var slider = gallery.querySelector('[id^="Slider-Gallery-"]');
    if (!slider) return;

    gallery.dataset.fpCompactDragReady = 'true';
    var mql = window.matchMedia(MQ);
    var syncQueued = false;

    function syncHeight() {
      syncQueued = false;
      if (!mql.matches) {
        gallery.style.removeProperty('--fp-gallery-height');
        return;
      }

      var list = getSlides(slider);
      if (!list.length) return;
      var active = list[getCurrentIndex(slider, list)];
      if (!active) return;

      var img = active.querySelector('img');
      var ratio = readRatio(img);
      var sliderWidth = slider.getBoundingClientRect().width || window.innerWidth;
      var slideWidth = active.getBoundingClientRect().width || (sliderWidth * (list.length > 1 ? 0.8 : 1));
      var desired = 0;

      if (ratio && slideWidth > 0) {
        var renderWidth = Math.min(slideWidth, ratio.width);
        desired = Math.round(renderWidth * ratio.height / ratio.width);
      } else if (img) {
        var box = img.getBoundingClientRect();
        if (box.height > 20) desired = Math.round(box.height);
      }

      if (!desired) desired = Math.round(slideWidth * 0.75) || 280;

      var minHeight = 190;
      var maxHeight = Math.min(560, Math.max(360, Math.round(window.innerHeight * 0.68)));
      desired = Math.max(minHeight, Math.min(desired, maxHeight));
      gallery.style.setProperty('--fp-gallery-height', desired + 'px');
    }

    function scheduleSync() {
      if (syncQueued) return;
      syncQueued = true;
      window.requestAnimationFrame(syncHeight);
    }

    scheduleSync();
    window.setTimeout(scheduleSync, 120);
    window.setTimeout(scheduleSync, 500);
    slider.addEventListener('load', scheduleSync, true);
    window.addEventListener('resize', scheduleSync, { passive: true });
    window.addEventListener('orientationchange', scheduleSync, { passive: true });

    if (window.MutationObserver) {
      var observer = new MutationObserver(scheduleSync);
      observer.observe(slider, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    var pointerId = null;
    var startX = 0;
    var startY = 0;
    var deltaX = 0;
    var horizontal = false;
    var moved = false;
    var blockClickUntil = 0;

    function clearDragStyles(list) {
      list.forEach(function (slide) {
        slide.classList.remove('fp-drag-prev', 'fp-drag-next');
        slide.style.removeProperty('transform');
      });
      slider.classList.remove('fp-mouse-dragging');
    }

    slider.addEventListener('pointerdown', function (event) {
      if (!mql.matches) return;
      if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (getSlides(slider).length < 2) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      deltaX = 0;
      horizontal = false;
      moved = false;

      try { slider.setPointerCapture(pointerId); } catch (error) {}
    });

    slider.addEventListener('pointermove', function (event) {
      if (pointerId === null || event.pointerId !== pointerId) return;

      deltaX = event.clientX - startX;
      var deltaY = event.clientY - startY;
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);

      if (!horizontal) {
        if (Math.max(absX, absY) < 6) return;
        if (absX <= absY * 1.15) return;
        horizontal = true;
        slider.classList.add('fp-mouse-dragging');
      }

      if (!horizontal) return;
      event.preventDefault();
      moved = true;

      var list = getSlides(slider);
      if (list.length < 2) return;
      var index = getCurrentIndex(slider, list);
      var direction = deltaX < 0 ? 1 : -1;
      var targetIndex = (index + direction + list.length) % list.length;
      var active = list[index];
      var target = list[targetIndex];

      clearDragStyles(list);
      slider.classList.add('fp-mouse-dragging');
      target.classList.add(direction === 1 ? 'fp-drag-next' : 'fp-drag-prev');
      active.style.setProperty('transform', 'translate3d(' + deltaX + 'px,0,0)', 'important');
      target.style.setProperty('transform', 'translate3d(' + deltaX + 'px,0,0)', 'important');
    }, { passive: false });

    function finishDrag(event, cancelled) {
      if (pointerId === null) return;
      if (event && event.pointerId !== undefined && event.pointerId !== pointerId) return;

      var list = getSlides(slider);
      var index = getCurrentIndex(slider, list);
      var direction = deltaX < 0 ? 1 : -1;
      var threshold = Math.max(35, slider.clientWidth * 0.09);
      var shouldMove = !cancelled && horizontal && Math.abs(deltaX) >= threshold && list.length > 1;
      var oldPointerId = pointerId;

      clearDragStyles(list);
      if (horizontal && moved) blockClickUntil = Date.now() + 450;

      pointerId = null;
      horizontal = false;
      moved = false;
      deltaX = 0;

      try { slider.releasePointerCapture(oldPointerId); } catch (error) {}

      if (shouldMove) {
        var nextIndex = (index + direction + list.length) % list.length;
        if (typeof slider.showSlideByIndex === 'function') {
          slider.showSlideByIndex(nextIndex);
        } else {
          var mediaId = list[nextIndex] && list[nextIndex].dataset.mediaId;
          if (mediaId && typeof gallery.setActiveMedia === 'function') {
            gallery.setActiveMedia(mediaId, false, false);
          }
        }
      }

      window.setTimeout(scheduleSync, 0);
      window.setTimeout(scheduleSync, 100);
    }

    slider.addEventListener('pointerup', function (event) {
      finishDrag(event, false);
    });

    slider.addEventListener('pointercancel', function (event) {
      finishDrag(event, true);
    });

    slider.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    slider.addEventListener('click', function (event) {
      if (Date.now() < blockClickUntil) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  }

  function init(scope) {
    ensureStyles();
    var base = scope && scope.querySelectorAll ? scope : document;
    var galleries = [];

    if (base.matches && base.matches('media-gallery')) galleries.push(base);
    if (base.querySelectorAll) {
      base.querySelectorAll('media-gallery').forEach(function (gallery) {
        galleries.push(gallery);
      });
    }

    galleries.forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
